import { Constants } from './../../shared/Helpers/constants';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserContext } from '../../_context/user.context';
import { UserService, AuthenticationService } from '../../_services';
import { Router, ActivatedRoute } from '@angular/router';
import { HelperFunctions } from '../../shared/Helpers/helperFunctions';
import { SharedService } from '../../shared/shared.service';
import { environment } from '@env/environment';
import { SecurityPoliciesOfUserForReset } from 'src/app/shared/interfaces';
import { Alert, AlertTypeEnum } from 'src/app/shared/Helpers/Alert';

@Component({
  selector: 'reset-password',
  templateUrl: './reset-pwd.component.html',
  providers: [UserContext]
})
export class ResetPwdComponent implements OnInit {
  public checkNewPassword: boolean = false;
  public identityType: any;
  public errorResetPassword: any;
  public passwordInput: string = 'password';
  public confirmPasswordInput: string = 'password';
  public passwordMode: boolean = true;
  public ResetPasswordForm: FormGroup;
  public logoPath: any;
  private returnUrl: any;
  private firstLoginExpire: boolean;
  public securityPolicyForReset: SecurityPoliciesOfUserForReset | any;
  public passwordCharNumber: number = 0;
  public upperCaseNo: number = 0;
  public lowerCaseNo: number = 0;
  public containsNo: number = 0;
  public specialCharNo: number = 0;
  public usernameChar: boolean = true;
  public passwordValidation: boolean = false;
  public usernameContains: boolean = true;
  public customRulesValidation: boolean = false;
  public passwordContainsSpace: boolean = false;
  public passwordContainsNames: boolean = false;

  constructor(
    private _fb: FormBuilder,
    private _authenticationServices: AuthenticationService,
    private _userService: UserService,
    private _userContext: UserContext,
    private _router: Router,
    private _route: ActivatedRoute,
    public sharedService: SharedService
  ) {
    this.returnUrl = this._route.snapshot.queryParams['returnUrl'] || environment.default_return_url;
    this.firstLoginExpire = this.sharedService.checkFirstLogin.value;
    this.initForm();
  }

  private initForm() {
    this.ResetPasswordForm = this._fb.group({
      oldPassword: ['', [Validators.required]],
      passwordGroup: this._fb.group({
        newPassword: ['', [Validators.required, Validators.minLength(6)]],
        confirmNewPassword: ['', [Validators.required, Validators.minLength(6)]]
      }, { validator: HelperFunctions.passwordMatcher }),
      checkNewPassword: ['', [Validators.required]]
    })
  }

  ngOnInit(): void {
    if (this._userContext.isAuthenticated) {
      this._userService.getPasswordPolicyByPersonId(this._userContext.personID).subscribe(res => {
        if (res) {
          this.securityPolicyForReset = res.body;
        }
      });
    } else {
      this._router.navigateByUrl('/login?returnUrl=' + this.returnUrl)
    }
  }

  ngDoCheck() {
    if (this.sharedService.loadedOrganisationByUrl.value) {
      if (this.sharedService.loginCustomisation.value != undefined && this.sharedService.loginCustomisation.value != null) {
        if (this.sharedService.LogoImage.value != null) {
          this.logoPath = null;
          this.logoPath = this.sharedService.LogoImage.value;
        } else {
          this.logoPath = Constants.logoPath;
        }
      } else {
        this.logoPath = Constants.logoPath;
      }
    } else {
      this.logoPath = Constants.logoPath;
    }
  }

  onSubmitForm() {
    const resetPasswordModel = this.ResetPasswordForm.value;
    let model = {
      newPassword: resetPasswordModel.passwordGroup.newPassword,
      oldPassword: resetPasswordModel.oldPassword
    }

    this._userService.resetPassword(model, this._userContext.personID).subscribe({
      next: () => {
        Alert.basicNotification(AlertTypeEnum.Success, "", "Password changed successfully")
        // check security questions:
        if (this.firstLoginExpire) {
          this._userService.getHomeUser(this._userContext.personID).subscribe((data) => {
            const users = data.body;
            this._userService.getSecurityQuestions(users[0].userType.id, users[0].organisation.id).subscribe((datasec) => {
              this._authenticationServices.logout();
              this._router.navigateByUrl('/login?returnUrl=' + this.returnUrl)
            });
          })
        } else {
          this._authenticationServices.logout();
          this._router.navigateByUrl('/login?returnUrl=' + this.returnUrl);
        }
      },
      error: (err) => {
        this.resetFormValidation;
        if (err.error.errorCode == 1006 && err.error.detailedMessage.startsWith("Bad password")) {
          Alert.basicNotification(AlertTypeEnum.Warning, "Old password", "The old password that you have entered is incorrect. Please try again.");
        } else if (err.error.errorCode == 1006) {
          Alert.basicNotification(AlertTypeEnum.Warning, "New password", "Your new password must be different from your old password. Please try again.");
        } else {
          Alert.basicNotification(AlertTypeEnum.Warning, "Password", err.detailedMessage);
        }
      }
    })
  }

  private resetFormValidation() {
    this.ResetPasswordForm.markAsPristine();
    this.ResetPasswordForm.markAsUntouched();
    this.ResetPasswordForm.updateValueAndValidity;
  }

  // check password strength
  public checkPasswordStrength(input: string) {
    const caseInsensitiveInput = input.toLowerCase();
    if (this.securityPolicyForReset != undefined) {
      this.passwordValidation = true;

      if (this.securityPolicyForReset.security.passwordUpperCaseRestriction) {
        this.upperCaseNo = 0;
        for (var i = 0; i < input.length; i++) {
          if (input[i] === input[i].toUpperCase() && input[i] !== input[i].toLowerCase()) {
            this.upperCaseNo++
          }
        }
        if (this.upperCaseNo < this.securityPolicyForReset.security?.passwordUpperCaseNo) {
          this.passwordValidation = false;
        }
      }
      if (this.securityPolicyForReset.security.usernameRestriction) {
        this.usernameChar = true;
        if (input.length > this.securityPolicyForReset.security.usernameCharacterNo || input.length == this.securityPolicyForReset.security.usernameCharacterNo) {
          if (this.securityPolicyForReset.firstname != "") {
            const firstname = this.securityPolicyForReset.firstname.split('').reduce((s, c) => { let l = s.length - 1; (s[l] && s[l].length < this.securityPolicyForReset.security.usernameCharacterNo) ? s[l] += c : s.push(c); return s; }, []);
            firstname.forEach((x: any) => {
              if (x.length == this.securityPolicyForReset.security.usernameCharacterNo) {
                if (caseInsensitiveInput.includes(x.toLowerCase())) {
                  this.usernameChar = false;
                  this.passwordValidation = false;
                }
              }
            })
          }
          if (this.securityPolicyForReset.middlename != "") {
            const middleName = this.securityPolicyForReset.middlename?.split('').reduce((s: any, c: any) => { let l = s.length - 1; (s[l] && s[l].length < this.securityPolicyForReset.security.usernameCharacterNo) ? s[l] += c : s.push(c); return s; }, []);
            middleName?.forEach((x: any) => {
              if (x.length == this.securityPolicyForReset.security.usernameCharacterNo) {
                if (caseInsensitiveInput.includes(x.toLowerCase())) {
                  this.usernameChar = false;
                  this.passwordValidation = false;
                }
              }
            })
          }
          if (this.securityPolicyForReset.lastname != "") {
            const surname = this.securityPolicyForReset.lastname?.split('').reduce((s, c) => { let l = s.length - 1; (s[l] && s[l].length < this.securityPolicyForReset.security.usernameCharacterNo) ? s[l] += c : s.push(c); return s; }, []);
            surname?.forEach((x: any) => {
              if (x.length == this.securityPolicyForReset.security.usernameCharacterNo) {
                if (caseInsensitiveInput.includes(x.toLowerCase())) {
                  this.usernameChar = false;
                  this.passwordValidation = false;
                }
              }
            })
          }
        }
        if (caseInsensitiveInput.includes(this.securityPolicyForReset.username?.toLowerCase()) || caseInsensitiveInput == this.securityPolicyForReset.username?.toLowerCase()) {
          this.usernameContains = false;
          this.passwordValidation = false;
        } else {
          this.usernameContains = true;
        }
      }
      if (this.securityPolicyForReset.security.passwordLowerCaseRestriction) {
        this.lowerCaseNo = 0;
        for (var i = 0; i < input.length; i++) {
          if (input[i] !== input[i].toUpperCase() && input[i] === input[i].toLowerCase()) {
            this.lowerCaseNo++
          }
        }
        if (this.lowerCaseNo < this.securityPolicyForReset.security?.passwordLowerCaseNo) {
          this.passwordValidation = false;
        }
      }
      if (this.securityPolicyForReset.security?.passwordNumberRestriction) {
        this.containsNo = 0;
        for (var i = 0; i < input.length; i++) {
          if (/[0-9]/.test(input[i])) {
            this.containsNo++;
          }
        }
        if (this.containsNo < this.securityPolicyForReset.security?.passwordNumberNo) {
          this.passwordValidation = false;
        }
      }
      if (this.securityPolicyForReset.security?.passwordSpecialCharRestriction) {
        var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,./~`-="
        this.specialCharNo = 0;
        for (var i = 0; i < input.length; i++) {
          if (specialChars.indexOf(input[i]) != -1) {
            this.specialCharNo++
          }
        }
        if (this.specialCharNo < this.securityPolicyForReset.security?.passwordSpecialCharNo!) {
          this.passwordValidation = false;
        }
      }
    }
    this.passwordCharNumber = input.length;
    if (this.passwordCharNumber < this.securityPolicyForReset.security?.passwordMinCharacterNo!) {
      this.passwordValidation = false;
    }

    if (this.securityPolicyForReset.security?.customRules?.length > 0) {
      var regexNotFound = 0;
      for (var i = 0; i < this.securityPolicyForReset.security?.customRules.length; i++) {
        if (!this.ResetPasswordForm.get('passwordGroup.newPassword').value.match(this.securityPolicyForReset.security?.customRules[i]?.regularExpression))
          regexNotFound++
      }
      if (regexNotFound > 0) {
        this.customRulesValidation = false;
        this.passwordValidation = false;
      }
      else {
        this.customRulesValidation = true;
      }
    }
    if (this.securityPolicyForReset.security.passwordSpaceRestriction) {
      this.passwordContainsSpace = false;
      if (input.indexOf(' ') > 0) {
        this.passwordContainsSpace = true;
        this.passwordValidation = false;
      }
    }
    if (this.securityPolicyForReset.security.passwordUsersNameRestriction) {
      this.passwordContainsNames = false;
      if (this.securityPolicyForReset.security?.minUsersNameCharacters == 0) {
        if (caseInsensitiveInput.includes(this.securityPolicyForReset.middlename) || caseInsensitiveInput.includes(this.securityPolicyForReset.firstname) || caseInsensitiveInput.includes(this.securityPolicyForReset.lastname) || caseInsensitiveInput.includes(this.securityPolicyForReset.displayname)) {
          this.passwordValidation = false;
          this.passwordContainsNames = true;
        }
      }
      if (this.securityPolicyForReset.security?.minUsersNameCharacters! > 0) {
        //check if length of firstName or surname or displayname or middleName is >= to this property value; if so => check if those words are used for password
        if (input.length >= this.securityPolicyForReset.security?.minUsersNameCharacters) {
          let fieldsToCheck: string[] = [this.securityPolicyForReset.firstname, this.securityPolicyForReset.displayname, this.securityPolicyForReset.lastname, this.securityPolicyForReset.middlename]
          
          var containsUsername = HelperFunctions.containsSubstringInList(caseInsensitiveInput, this.securityPolicyForReset.security?.minUsersNameCharacters + 1, fieldsToCheck)
          
          this.passwordValidation = containsUsername == true ? false : this.passwordValidation;
          this.passwordContainsNames = containsUsername;
        }
      }
    }
  }
 
  checkEquality() {
    const resetPasswordModel = this.ResetPasswordForm.value;
    if (resetPasswordModel.oldPassword.toLowerCase() == resetPasswordModel.passwordGroup.newPassword.toLowerCase()) {
      this.checkNewPassword = true;
      this.ResetPasswordForm.patchValue({
        checkNewPassword: ''
      });
    } else {
      this.checkNewPassword = false;
      this.ResetPasswordForm.patchValue({
        checkNewPassword: true
      })
    }
  }

  passwordModeOn(check: boolean, inputField: boolean) {
    if (!check) {
      if (inputField) {
        this.passwordInput = 'password';
      } else {
        this.confirmPasswordInput = 'password';
      }
      this.passwordMode = true;
    } else {
      if (inputField) {
        this.passwordInput = 'text';
      } else {
        this.confirmPasswordInput = 'text';
      } this.passwordMode = false;
    }
  }

  chooseOtherAcount() {
    localStorage.removeItem(Constants.localStorage_currentUser);
    this._router.navigate(['/login']);
  }
}
